@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.InfoPopOut {
  @extend %font-family-primary;

  min-width: 9em;
  max-width: 18em;
  padding: 1em;
  white-space: pre-line;

  &.widerWidth {
    max-width: 27.5em;
  }
}
